import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_USERS,
  ADD_NEW_USER,
  DELETE_USER,
  UPDATE_USER,
  GET_ACCOUNT,
  RESEND_USER_INVITE,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS,
  GET_CAMPAIGN_SPENDS,
  GET_CAMPAIGNS_BY_ACCOUNT,
  GET_AD_GROUPS_BY_CAMPAIGN,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS,
} from "./actionTypes"

import {
  getUsersSuccess,
  getUsersFail,
  addUserFail,
  deleteUserSuccess,
  deleteUserFail,
  getAccountSuccess,
  getAccountError,
  resendUserInviteSuccess,
  resendUserInviteError,
  getAdminManageClientAccountWithBrandsSuccess,
  getAdminManageClientAccountWithBrandsError,
  getCampaignSpendsError,
  getCampaignSpendsSuccess,
  getCampaignsByAccountSuccess,
  getCampaignsByAccountError,
  getAdGroupsByCampaignSuccess,
  getAdGroupsByCampaignError,
  getAdminManageClientSourceTypesError,
  getAdminManageClientSourceTypesSuccess,
  getAdminSourceTypesByAccountSuccess,
  getAdminSourceTypesByAccountError,
  getAdminMarketingGroupsSuccess,
  getAdminMarketingGroupsError,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getUsers,
  addNewUser,
  updateUser,
  deleteUser,
  fetchAccount,
  genericPostRequest,
  genericGetRequest
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { USER_INVITE_STR } from "common/sf_strings"
import { bsh_getAdminUserDetails, bsh_getClientUserDetails } from "helpers/sf_browser_storage_helper"
import { logoutUser } from "store/actions"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"
import { errorMessages } from "common/utils/data_validations"

function* fetchUsers() {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      getUsers,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    //  let users = []
    //  response.data.map(e=>{
    //     users.push({'user': e.user.email, 'last_name': e.user.last_name, 'first_name': e.user.first_name, 'role': e.role.name})
    //  })
    yield put(getUsersSuccess(response.data))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onUpdateUser({ payload: user }) {
  try {
    let user_auth = localStorage.getItem("authUser")
    yield call(
      updateUser,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships/${user.membership_id}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        user: user,
      }
    )

    // XXX: If we pass a new email, then we actually create a new user
    // meaning that we have to get users again since backend may/may not have an extra resource
    // yield put(addUserSuccess(response))
    // window.location.reload()
    const response = yield call(
      getUsers,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(getUsersSuccess(response.data))
  } catch (error) {
    yield put(addUserFail(error))
  }
}

function* onDeleteUser({ payload: email }) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      deleteUser,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships/123`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        email: email,
      }
    )
    yield put(deleteUserSuccess(response))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddNewUser({ payload: user }) {
  try {
    let user_auth = localStorage.getItem("authUser")
    yield call(
      addNewUser,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        user: user,
      }
    )

    // XXX: Getting memberships again since POST memberships returns
    // a membership and we've lost information about memberships in
    // reducer (as we extract the users from payload)
    const response = yield call(
      getUsers,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(getUsersSuccess(response.data))
  } catch (error) {
    yield put(addUserFail(error))
  }
}

function* onGetAccount() {
  try {
    let user_auth = localStorage.getItem("authUser")
    if (!user_auth) {
      throw "User is not logged in";
    }
    const account_id = JSON.parse(user_auth).user.account_id

    const response = yield call(
      fetchAccount,
      `${AppConfiguration.BACKEND_URL}/api/v1/accounts/${account_id}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )

    yield put(getAccountSuccess(response))
  } catch (error) {
    yield put(getAccountError(error))
    // redirect to login if this API gives error
    if (error === errorMessages["ERR_DEVISE_SIGNATURE_HAS_EXPIRED"]) {
      yield put(logoutUser({ redirect_url: 'login?session_expired=1' }))
    }
  }
}

function* onResendInvite(user) {
  try {
    const { user: auth_user } = JSON.parse(localStorage.getItem('authUser'));
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/memberships/resend_invite/${user.payload.membership_id}`,
      {
        body: JSON.stringify({

        }),
        headers: {
          Authorization: auth_user.token,
          'account-id': auth_user.account_id,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(resendUserInviteSuccess(response))
  } catch (error) {
    yield put(resendUserInviteError({ type: USER_INVITE_STR.RESEND_ERROR_TYPE, message: `Failed to resend invitation to ${user.payload.email}` }))
  }
}

function* onGetAdminManageClientAccountWithBrands() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_client_account_with_brands`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminManageClientAccountWithBrandsSuccess(response))
  } catch (error) {
    yield put(getAdminManageClientAccountWithBrandsError(error))
  }
}

function* onGetCampaignSpends(action) {
  try {
    let user = bsh_getClientUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_spends`,
      action.payload.queryParams,
      {
        'Authorization': user.token,
        'account-id': user.account_id,
        'Content-Type': 'application/json',
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCampaignSpendsSuccess(response))
  } catch (error) {
    yield put(getCampaignSpendsError(error))
  }
}

function* onGetCampaignsByAccount(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/get_campaigns_by_account`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(getCampaignsByAccountSuccess(response))
  } catch (error) {
    yield put(getCampaignsByAccountError(error))
  }
}

function* onGetAdGroupsByCampaign(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/get_ad_groups_by_campaign`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(getAdGroupsByCampaignSuccess(response))
  } catch (error) {
    yield put(getAdGroupsByCampaignError(error))
  }
}

function* onGetAdminManageClientSourceTypes(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/get_source_types`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(getAdminManageClientSourceTypesSuccess(response))
  } catch (error) {
    yield put(getAdminManageClientSourceTypesError(error))
  }
}

function* onGetAdminManageClientSourceTypesByAccount(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/get_source_types_by_account`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(getAdminSourceTypesByAccountSuccess(response))
  } catch (error) {
    yield put(getAdminSourceTypesByAccountError(error))
  }
}

function* onGetAdminManageClientMarketingGroups() {
  try {
    const user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/get_marketing_groups`,
      {
        body: JSON.stringify({}),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(getAdminMarketingGroupsSuccess(response))
  } catch (error) {
    yield put(getAdminMarketingGroupsError(error))
  }
}


function* usersSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDeleteUser)
  yield takeEvery(GET_ACCOUNT, onGetAccount)
  yield takeEvery(RESEND_USER_INVITE, onResendInvite)
  yield takeEvery(GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS, onGetAdminManageClientAccountWithBrands)
  yield takeEvery(GET_CAMPAIGN_SPENDS, onGetCampaignSpends)
  yield takeEvery(GET_CAMPAIGNS_BY_ACCOUNT, onGetCampaignsByAccount)
  yield takeEvery(GET_AD_GROUPS_BY_CAMPAIGN, onGetAdGroupsByCampaign)
  yield takeLatest(GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES, onGetAdminManageClientSourceTypes)
  yield takeEvery(GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT, onGetAdminManageClientSourceTypesByAccount)
  yield takeEvery(GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS, onGetAdminManageClientMarketingGroups)
}

export default usersSaga
